export enum FileType {
  NotSet,
  Contract,
  Asset,
  Concept
}

export type FilePayload = {
  fileContent: string;
  fileName: string;
  campaignId: string;
  fileType: FileType;
}
